import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import BindingMixin from '../../../mixins/binding-mixin';
import ButtonGroup from '../../form/button-group';
import FieldSelect from '../../form/field/field-select';
import Show from '../../layout/show';
import List from '../list';

export default createReactClass({
  displayName: 'lookup-list',
  mixins: [BindingMixin],

  getInitialState() {
    const { value, lookups, searches } = this.props;
    const val = value || [];
    const obj = { list: [], lookup: '', search: '', menu: 'search' };
    if (_.isArray(val)) {
      obj.menu = 'list';
    }
    if (lookups[val] != null) {
      obj.menu = 'lookup';
    }

    obj[obj.menu] = val || '';

    return obj;
  },

  getDefaultProps() {
    return {
      lookups: {}
    };
  },

  render() {
    let items;
    if (this.props.lookups.length > 0) {
      items = this.props.lookups;
    } else {
      items = Object.keys(this.props.lookups).map((key) => {
        return {
          name: this.props.lookups[key].niceName,
          value: key
        };
      });
    }

    return (
      <div>
        <ButtonGroup value={this.state.menu} onChange={this.onMenu} src={['list', 'lookup']} />
        <Show if={this.state.menu === 'list'}>
          <List className="w-[160px]" value={this.state.list} onChange={this.onList} />
        </Show>
        <Show if={this.state.menu === 'lookup'}>
          <FieldSelect
            className="w-[190px]"
            value={this.state.lookup}
            valueMember="value"
            displayMember="name"
            onChange={this.onLookup}
            items={items}
            placeholder="Please Select A DataSource"
          />
        </Show>
      </div>
    );
  },

  onMenu(menu) {
    this.setState({ menu });
    return this.props.onChange != null
      ? this.props.onChange.call(this, this.state[menu])
      : undefined;
  },

  onList(value) {
    return this.props.onChange != null ? this.props.onChange.call(this, value) : undefined;
  },

  onLookup(e) {
    this.setState({ lookup: e.target.value });
    return this.props.onChange != null ? this.props.onChange.call(this, e.target.value) : undefined;
  }
});
